import { get } from 'lodash/fp';
import React, { PropsWithChildren } from 'react';
import { useVisibility } from '@/hooks/useVisibility';

export const withVisibility =
  <P extends object>(Component: React.FC<P>, visibilityPath?: string[]) =>
  ({ children, ...props }: PropsWithChildren<P>) => {
    const visibility = get(visibilityPath || 'visibility', props);
    const { isVisible } = useVisibility(visibility as VisibilityVariant);
    if (!isVisible) return null;
    return <Component {...(props as P)}>{children}</Component>;
  };
